import { takeLatest, put, call } from 'redux-saga/effects';
import {
  FETCH_SUPPORT_CHAT_MODULE_TAGS,
  DELETE_SUPPORT_CHAT_MODULE_TAG,
  UPDATE_SUPPORT_CHAT_MODULE_TAG,
  ADD_SUPPORT_CHAT_MODULE_TAG,
  setSupportChatModuleTagsLoading,
  setSupportChatModuleTags,
  setSupportChatModuleTagUpdating,
} from '../actions/supportChatModuleTagsAction';
import { POPUP_ALERT } from '../actions/alert';
import {
  fetchSupportChatModuleTagsAPI,
  updateSupportChatModuleTagAPI,
  deleteSupportChatModuleTagAPI,
  addSupportChatModuleTagAPI,
} from '../api/supportChatModuleTags';

const supportChatModuleTagsSagas = [
  takeLatest(FETCH_SUPPORT_CHAT_MODULE_TAGS, fetchSupportChatModuleTagsSaga),
  takeLatest(UPDATE_SUPPORT_CHAT_MODULE_TAG, updateSupportChatModuleTagsSaga),
  takeLatest(DELETE_SUPPORT_CHAT_MODULE_TAG, deleteSupportChatModuleTagSaga),
  takeLatest(ADD_SUPPORT_CHAT_MODULE_TAG, addSupportChatModuleTagSaga),
];

export default supportChatModuleTagsSagas;

function* fetchSupportChatModuleTagsSaga() {
  try {
    yield put(setSupportChatModuleTagsLoading(true));
    const { data: response } = yield call(fetchSupportChatModuleTagsAPI);
    yield put(setSupportChatModuleTags(response.data));
    yield put(setSupportChatModuleTagsLoading(false));
  } catch (e) {
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Something went wrong.' },
    });
    yield put(setSupportChatModuleTagsLoading(false));
  }
}

function* addSupportChatModuleTagSaga({ data }) {
  try {
    yield put(setSupportChatModuleTagUpdating(true));
    yield call(addSupportChatModuleTagAPI, data);
    yield call(fetchSupportChatModuleTagsSaga);
    yield put(setSupportChatModuleTagUpdating(false));
    yield put({
      type: POPUP_ALERT,
      data: { type: 'success', message: 'Created Successfully' },
    });
  } catch (e) {
    const errorMessage =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      'Something went wrong.';
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: errorMessage },
    });
    yield put(setSupportChatModuleTagUpdating(false));
  }
}

function* updateSupportChatModuleTagsSaga({ data }) {
  try {
    yield put(setSupportChatModuleTagUpdating(true));
    yield call(updateSupportChatModuleTagAPI, data);
    yield call(fetchSupportChatModuleTagsSaga);
    yield put(setSupportChatModuleTagUpdating(false));
    yield put({
      type: POPUP_ALERT,
      data: { type: 'success', message: 'Updated Successfully' },
    });
  } catch (e) {
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Something went wrong.' },
    });
    yield put(setSupportChatModuleTagUpdating(false));
  }
}

function* deleteSupportChatModuleTagSaga({ data }) {
  try {
    yield put(setSupportChatModuleTagUpdating(true));
    yield call(deleteSupportChatModuleTagAPI, data);
    yield call(fetchSupportChatModuleTagsSaga);
    yield put(setSupportChatModuleTagUpdating(false));
    yield put({
      type: POPUP_ALERT,
      data: { type: 'success', message: 'Deleted Successfully' },
    });
  } catch (e) {
    const errorMessage =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      'Something went wrong.';
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: errorMessage },
    });
    yield put(setSupportChatModuleTagUpdating(false));
  }
}
